import Promise from 'bluebird';
import { GridCustomizedPopupEditor } from '@bingads-webui-campaign/grid-customized-popup-editor';
import { StatusPopupView } from './status-popup-view';

/**
 * Renders the popup editor for Status property.
 *
 * @param {String} currentStatus - current status of the item
 * @param {Array} param.statusOptions - status options to be shown in view
   *   it should be an array of { name, value } objects
   *   value is the value to be returned to user when status updated
   *   name is the one to be used to generate text & icon style based, in the format of
   *     text/title: search by key EntityStatus_$(name)
   *     iconClass: status$(name)_icon
   *     textClass: status$(name)
 * @param {Object} position - object to indicate the position of the table cell.
 * @param {Object} param.i18n - the localization settings, by default return the provided key
 * @param {String} param.className - allow custom class name for the container
 * @param {Boolean} param.isForVNext -- is being used for vNext grid
 * @param {boolean} param.adjustTopPosition - whether to adjust top position,
   default true
 * @return {Object} A promise that will resolve with the selected data.
 */
export function renderStatusPopupEditor({
  currentStatus, statusOptions, position, i18n, className, isForVNext, adjustTopPosition = true,
}) {
  const statusPopupView = new StatusPopupView({
    currentStatus,
    statusOptions,
    i18n,
  }).render();

  const popupEditor = new GridCustomizedPopupEditor({
    editorView: statusPopupView,
    cellPosition: position,
    className: className || 'status-popupeditor',
    renderBelow: true,
    adjustTopPosition,
    parentContainerSelector: isForVNext ? '.grid-and-disclaim-container' : null,
  }).render();

  return new Promise((resolve) => {
    popupEditor.on('close', status => resolve(status));
  });
}
